import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LaundryBoxManagement = ({ children }) => {
  const Navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/admin/laundry-box") {
      Navigate("/admin/laundry-box/laundry-box-tables");
    }
  }, [location, Navigate]);
  return (
    <div className="mt-4 ">
      <section>
        <div className="container">
          <div className="row">
            {children}
            {/* Add your store management components here */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LaundryBoxManagement;
